// extracted by mini-css-extract-plugin
export var card = "_m2-5";
export var cardSelected = "_m2-4";
export var image = "_m2-3";
export var modal = "_m2-0";
export var modalContent = "_m2-1";
export var table = "_m2-2";